import AWS from "aws-sdk";
import toast from "react-hot-toast";
import { sendWhatsAppMessage } from "./sendPdfToWhatsApp";
import { Buffer } from "buffer";
import { isDev } from "../utils/getApiUrl";

const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_INVOICE_accessKeyId,
  secretAccessKey: process.env.REACT_APP_INVOICE_secretAccessKey,
  region: process.env.REACT_APP_INVOICE_region,
});

export const uploadToS3 = async (
  mobileNumber: string,
  base64Data: string,
  originalFileName: string
): Promise<{ success: boolean; url?: string }> => {
  try {
    const buffer = Buffer.from(base64Data, "base64");

    const s3FileName = `invoices/${Date.now()}_invoice.pdf`;
    let bucketName = "";
    if (isDev) {
      if (!process.env.REACT_APP_INVOICE_BUCKET_NAME_DEV) {
        throw new Error("Bucket name is not defined in environment variables.");
      }
      bucketName = process.env.REACT_APP_INVOICE_BUCKET_NAME_DEV;
    } else {
      if (!process.env.REACT_APP_INVOICE_BUCKET_NAME_PROD) {
        throw new Error("Bucket name is not defined in environment variables.");
      }
      bucketName = process.env.REACT_APP_INVOICE_BUCKET_NAME_PROD;
    }

    const uploadParams = {
      Bucket: bucketName,
      Key: s3FileName,
      Body: buffer,
      ContentType: "application/pdf",
    };

    await s3.upload(uploadParams).promise();

    const generatePresignedUrl = async (fileKey: string): Promise<string> => {
      const params = {
        Bucket: process.env.REACT_APP_INVOICE_BUCKET_NAME_DEV,
        Key: fileKey,
      };
      return s3.getSignedUrlPromise("getObject", params);
    };

    const presignedUrl = await generatePresignedUrl(s3FileName);

    sendWhatsAppMessage(mobileNumber, presignedUrl);
    return { success: true, url: presignedUrl };
  } catch (error) {
    console.error("S3 Upload Error:", error);
    toast.error("Failed to upload PDF.");
    return { success: false }; // move this inside catch block
  }
};
